<template>
  <div id="Dashboard">
    <ApopBar/>

    <b-container>
      <b-row>
        <b-col class="text-center">
          <b-alert variant="danger" :show=!this.user.attributes.email_verified style="display:inline-block;">
            Please check your profile and verify your email address. Passwords cannot be changed or recovered until
            verification is complete.
          </b-alert>
          <b-alert variant="warning" show style="display:inline-block;">
            Welcome to the new Apoplectic.net! As the dust settles on the new layout and foundational tech, please
            report issues as you find them.
          </b-alert>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <MumbleCard/>
        </b-col>
        <b-col>
          <RecordingCard/>
        </b-col>
        <b-col>
          <SteamCard/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { Auth } from 'aws-amplify'
  import ApopBar from '../components/ApopBar'
  import MumbleCard from '../components/MumbleCard'
  import RecordingCard from '../components/RecordingCard'
  import SteamCard from '../components/SteamCard'

  export default {
    name: 'dashboard',
    components: {
      SteamCard,
      ApopBar,
      MumbleCard,
      RecordingCard
    },
    data () {
      return {
        showNonValidatedMsg: false,
        //again, a shell to prevent console errors/race condition
        user: {
          attributes: {
            email_verified: false
          }
        }
      }
    },
    mounted () {
      Auth.currentAuthenticatedUser().then(user => {
        this.user = user
      })
    },
    methods: {
      signOut (e) {
        e.preventDefault()
        Auth.signOut()
          .then(data => {
            this.$store.dispatch('completeSignOut')
            this.$router.push('/')
          })
          .catch(err =>
            console.log(err))
      }
    }
  }
</script>
